export default "__VITE_ASSET__CRdtflct__"